import { BITACORA_TYPES } from '../constants/bitacora.types'
import { Bitacora, BitacoraAction, BitacoraState } from '../interfaces/bitacora.interface'

const initialState: BitacoraState = {
  dataBitacora: [],
}

const bitacoraReducer = (
  state: Bitacora = initialState,
  action: BitacoraAction
): BitacoraState => {
  switch (action.type) {
    case BITACORA_TYPES.BITACORA_SET_HISTORIAL_RESULT:
      return {...state, dataBitacora: action.payload}
    case BITACORA_TYPES.BITACORA_CLEAR_MODULE:
      return { ...initialState }
    default:
      return state
  }
}

export default bitacoraReducer
